module.exports = __webpack_public_path__ + "static/media/address.d174efa7.gif";